import { useQuery } from '@tanstack/react-query';
import useLocaleQueryFilter from '../../utils/useLocaleQueryFilter';
import { ImageType } from './useProducts';

export type CategoryCard = {
  slug: string;
  defaultImageDesktop: ImageType;
  defaultImageMobile: ImageType;
  imageDesktop: ImageType;
  imageMobile: ImageType;
  id: number;
};

export type Category = {
  id: number;
  name: string;
  description: string;
  slug: string;
  hideFilters: number;
  children: CategoryCard[];
};

export default function useCategory(filter: object) {
  const localeFilter = useLocaleQueryFilter(filter);

  return useQuery<Category, Error>(['categories/findOne', localeFilter]);
}
